import { render } from "./DefaultTimeValueForStartDateAndEndDate.vue?vue&type=template&id=10012731"
import script from "./DefaultTimeValueForStartDateAndEndDate.vue?vue&type=script&lang=js"
export * from "./DefaultTimeValueForStartDateAndEndDate.vue?vue&type=script&lang=js"
script.render = render

export default script